import {
  Box,
  CircularProgress,
  LinearProgress,
  Typography,
} from "@mui/material";

interface UploadSpinnerProps {
  label: string;
  completed: number;
  total: number;
}

export const UploadSpinner = ({
  label,
  completed,
  total,
}: UploadSpinnerProps) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 2,
      py: 6,
    }}
  >
    <CircularProgress size={48} />
    <Typography variant="h6">{label}</Typography>
    <Box sx={{ width: "100%", maxWidth: 400 }}>
      <LinearProgress
        variant="determinate"
        value={total > 0 ? (completed / total) * 100 : 0}
      />
    </Box>
  </Box>
);
